import { Injectable } from '@angular/core';
import { GigsumoConstants } from './GigsumoConstants';
import { TimezoneDatePipe } from '../timezone-date.pipe';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor(private dateTransform: TimezoneDatePipe) { }


  workBook: any;
  headerStyle = {
    font: { bold: true, color: { argb: '111' } },
    alignment: { horizontal: 'center' },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '7a76cd' } },
  };
  private totalCount: number;

  setCount(val: number) {
    this.totalCount = val;
  }

  getTotalCount() {
    return this.totalCount;
  }
  //excel download function for all admin module menus by monisha
  async downloadExcel(data: Array<any>, headers: Array<any>, fileName: string, sheetName: string = 'Sheet 1') {
    if (!data || !headers || !fileName || !sheetName) {
      throw new Error('Input is missing');
    }

    // Dynamic import of ExcelJS to reduce initial bundle size
    const ExcelJS = await import('exceljs');
    this.workBook = new ExcelJS.Workbook();
    const worksheet = this.workBook.addWorksheet(sheetName);

    worksheet.columns = headers.map((header) => ({
      header: header.header,
      key: header.key,
      width: header.width || 20,
    }));

    worksheet.getRow(1).eachCell((cell: any) => {
      cell.style = this.headerStyle;
    });

    const rows = data.map((item) => {
      return headers.map((header) => {
        switch (header.key) {
          case 'owner':
            return `${(item.userDetail?.firstName || item.userData?.firstName || '')} ${(item.userDetail?.lastName || item.userData?.lastName || '')}`.trim();
          case 'GigsumoNo':
            return item.gigsumoNo ? item.gigsumoNo : 'N/A';
          case 'email':
            return item.userDetail?.email || item.userData?.email || item.email;
          case 'Super Admin':
            return 'Super Admin';
            case 'userTyperole':
              const userType = (item.userDetail?.userType || item.userType || '');
              const transformedUserType = this.applyMtaPipe(userType); // Apply MTA transformation
              return this.touserTitleCase(transformedUserType) ? this.touserTitleCase(transformedUserType) : 'N/A';
            case 'createdOn':
              case 'modifiedOn':
              case 'lastLoggedIn':
              case 'lastLoggedOn':
              case 'startDate':
                if (!item[header.key]) {
                  return 'N/A';
                }
                const date = new Date(item[header.key]);
                return isNaN(date.getTime())
                  ? 'N/A'
                  // : date.toLocaleDateString('en-US', {
                  //     year: 'numeric',
                  //     month: '2-digit',
                  //     day: '2-digit'
                  //   });
                  : this.dateTransform.transform(date,'MM/dd/yyyy');
          case 'company':
            return item.organisation ? item.organisation : 'N/A';

          case 'client':
            return item.clientType ? item.clientType : 'N/A';
          case 'actual':
            return item.benefitsUsageAndBalance?.actual || 0;
          case 'available':
            return item.benefitsUsageAndBalance?.available || 0;

          case 'Ctype':
            return item.type && item.type.length > 0 ? item.type : 'N/A';
          case 'BusinessNetworks':
            return item.businessNetworks && item.businessNetworks.length > 0 ? item.businessNetworks.join(', ') : 'N/A'; // Checking if array is empty

          case 'status':
          case 'userStatus':
          case 'connectionStatus':
            const status = item[header.key] ?? '';
            switch (status) {
              case 'REQUEST_SENT':
                return 'Requested';
              case 'REQUEST_RECEIVED':
                return 'Request Received';
              default:
                return this.toTitleCase(status);
            }

          case 'utilized':
            return item.benefitsUsageAndBalance?.utilized || 0;

          case 'JOBS_CANDIDATE_ACTIVE_CREATIONS.actual':
            return item.benefitsUsages.find(i => i.benefitKey == 'JOBS_CANDIDATE_ACTIVE_CREATIONS')?.actual || 0;

          case 'JOBS_CANDIDATE_ACTIVE_CREATIONS.utilized':
            return item.benefitsUsages.find(i => i.benefitKey == 'JOBS_CANDIDATE_ACTIVE_CREATIONS')?.utilized || 0;

          case 'JOBS_CANDIDATE_SPOTLIGHTS.actual':
            return item.benefitsUsages.find(i => i.benefitKey == 'JOBS_CANDIDATE_SPOTLIGHTS')?.actual || 0;

          case 'JOBS_CANDIDATE_SPOTLIGHTS.utilized':
            return item.benefitsUsages.find(i => i.benefitKey == 'JOBS_CANDIDATE_SPOTLIGHTS')?.utilized || 0;

          default:

            return item[header.key] ?? '';
        }
      });
    });

    worksheet.addRows(rows);


    worksheet.columns.forEach((column: any) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const length = String(cell.value || '').length;
        maxLength = Math.max(maxLength, length);
      });
      column.width = maxLength + 2;
    });


    this.workBook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });

  }


  toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
    });
  }
  applyMtaPipe(value: string): string {
    if (!value) return value;
    if (value === GigsumoConstants.MTA || value === GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION || value === GigsumoConstants.MTA_TITLECASE) {
      return GigsumoConstants.MANAGER;
    }
    return value;
  }
  touserTitleCase(str: string): string {
    if (!str) return str;
    return str
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
